import type { LocalizationMap } from '@Primitive/Localization/Localization';
// ------------------------------------------------------------------------------------------------
export const enum TSSavedDataChartUILabelKey {
    // Widget
    SyncWithChartsDateRange = "sync-with-charts-date-range",
    ExportTo = "export-to",
    ExportToExcel = "export-to-excel",
    ExportToCSV = "export-to-csv",
    ResetView = "reset-view",
    EnableEditMode = "enable-edit-mode",
    DisableEditMode = "disable-edit-mode",
    SeparateCharts = "separate-charts",
    CommonChart = "common-chart",
    Value = "value-list-label_value",
    Name = "value-list-label_name",
    ToolbarSeparator = 'toolbar-separator',

    // Settings
    ChartType = "chart-type",
    ChartTypeLine = "chart-type-line",
    ChartTypeScatter = "chart-type-scatter",
    ChartTypeBar = "chart-type-bar",
    ChartTypeLineWithPoints = "chart-type-line-with-points",
    GridLines = "grid-lines",
    ShowStats = "show-stats",
    minColor = "min-color",
    maxColor = "max-color",
    ShowDateRange = "show-date-range",
    AutoValueRange = "auto-value-range",
    initialTimeRangeDays = "initial-time-range-days",
    DownloadExcel = "download-excel",
    ShowMarkersOnHover = "show-markers-on-hover",
    ShowValueList = "show-value-list",
    ShowFloatingLabels = "show-floating-labels",
    ShowOnlyCurrentFloatingLabel = "show-only-current-floating-label",
    FloatingLabelsInfoFontColor = "floating-label-info-font-color",
    FocusLastValue = "focus-last-value",
    None = "none",
    ViewType = "view-type",
    CommonCharts = "common-charts"
}
// --------------------------------------------------------------------------------------------
export const TimeSeriesSavedDataChartLocalizationTextMapKey: string = "Primitive_TimeSeriesSavedDataChart";
// --------------------------------------------------------------------------------------------
export function GeTimeSeriesSavedDataChartLocalizationDictionary(): LocalizationMap {
    return {
        [TSSavedDataChartUILabelKey.SyncWithChartsDateRange]: "Sync with Chart's Date Range",
        [TSSavedDataChartUILabelKey.ExportTo]: "Export to...",
        [TSSavedDataChartUILabelKey.ExportToExcel]: "Export to Excel",
        [TSSavedDataChartUILabelKey.ExportToCSV]: "Export to CSV",
        [TSSavedDataChartUILabelKey.ResetView]: "Reset View",
        [TSSavedDataChartUILabelKey.EnableEditMode]: "Edit",
        [TSSavedDataChartUILabelKey.DisableEditMode]: "Exit Editing",
        [TSSavedDataChartUILabelKey.SeparateCharts]: "Separate Charts",
        [TSSavedDataChartUILabelKey.CommonChart]: "Common Chart",
        [TSSavedDataChartUILabelKey.Value]: "Value",
        [TSSavedDataChartUILabelKey.Name]: "Name"
    };
}
// --------------------------------------------------------------------------------------------
export const TSSeriesSavedDataSettingsLocalizationTextMapKey: string = "Primitive_TSSavedDataChartSettings";
// --------------------------------------------------------------------------------------------
export function GetTSSeriesSavedDataSettingsLocalizationDictionary(): LocalizationMap {
    return {
        [TSSavedDataChartUILabelKey.ChartType]: "Chart Type",
        [TSSavedDataChartUILabelKey.ChartTypeLine]: "Line",
        [TSSavedDataChartUILabelKey.ChartTypeScatter]: "Scatter",
        [TSSavedDataChartUILabelKey.ChartTypeBar]: "Bar",
        [TSSavedDataChartUILabelKey.ChartTypeLineWithPoints]: "Line with points",
        [TSSavedDataChartUILabelKey.GridLines]: "Grid Lines",
        [TSSavedDataChartUILabelKey.ShowStats]: "Show Min/Max/Avg",
        [TSSavedDataChartUILabelKey.minColor]: "Min Color",
        [TSSavedDataChartUILabelKey.maxColor]: "Max Color",
        [TSSavedDataChartUILabelKey.ShowDateRange]: "Show Date Range",
        [TSSavedDataChartUILabelKey.AutoValueRange]: "Auto Value Range",
        [TSSavedDataChartUILabelKey.initialTimeRangeDays]: "Initial Days Period",
        [TSSavedDataChartUILabelKey.DownloadExcel]: "Excel Download",
        [TSSavedDataChartUILabelKey.ShowMarkersOnHover]: "Show markers on hover",
        [TSSavedDataChartUILabelKey.ShowValueList]: "Show Value List",
        [TSSavedDataChartUILabelKey.ShowFloatingLabels]: "Show Floating Labels",
        [TSSavedDataChartUILabelKey.ShowOnlyCurrentFloatingLabel]: "Show Only Current Point Floating Label",
        [TSSavedDataChartUILabelKey.FloatingLabelsInfoFontColor]: "Floating Labels Font Color",
        [TSSavedDataChartUILabelKey.ViewType]: "View Type",
        [TSSavedDataChartUILabelKey.FocusLastValue]: "Focus Last Value",
        [TSSavedDataChartUILabelKey.None]: "None",
        [TSSavedDataChartUILabelKey.CommonCharts]: "Common Chart",
    };
}
// --------------------------------------------------------------------------------------------